import { Service } from './types'
import EntraIMG from '../../../assets/images/Entra.png'
import AzureFundamentalsIMG from '../../../assets/images/Microsoft-Azure.png'
import AzureAdminIMG from '../../../assets/images/cloud-security.png'

export const services: Service[] = [
  {
    id: 1,
    icon: AzureFundamentalsIMG,
    alt: 'Azure Icon',
    title: 'Formation Sécurité & Architecture Cloud',
    subtitle: 'Formation administrateur identités et accès.',
    description: 'Apprenez à exploiter les solutions essentielles de sécurité et de gestion des identités Microsoft.',
    link: '/academy/cloudFundamentals',
  },
  {
    id: 2,
    icon: EntraIMG,
    alt: 'Azure Admin Icon',
    title: 'Services Managés Azure',
    subtitle: 'Gestion opérationnelle du cloud',
    description: 'Maîtrisez le déploiement, la configuration et la gestion des ressources Azure pour une infrastructure cloud optimale.',
    link: '/academy/azureAdmin',
  },
  {
    id: 3,
    icon: AzureAdminIMG,
    alt: 'Azure Fundamentals Icon',
    title: 'Azure Cloud Fundamentals',
    subtitle: 'Les bases essentielles du cloud Azure',
    description: 'Découvrez les concepts fondamentaux du cloud computing et familiarisez-vous avec les services de base de Microsoft Azure.',
    link: '/academy/securitycloud',
  },
];
